module.exports = __webpack_public_path__ + "img/PriceQuotations_WaitingForCustomerAccept.b0f0e456.svg";